'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TenantSelector = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Modal = require('@cimpress/react-components/lib/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _lodash = require('lodash.find');

var _lodash2 = _interopRequireDefault(_lodash);

var _SelectorModal = require('./SelectorModal');

var _SelectorModal2 = _interopRequireDefault(_SelectorModal);

var _fulfillerIdentity = require('../../services/fulfillerIdentity');

var _merchantConfig = require('../../services/merchantConfig');

var _customizr = require('../../services/customizr');

var _constants = require('../../constants');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var noop = function noop() {};
/* eslint-disable jsx-a11y/no-static-element-interactions */


var HeaderLink = function HeaderLink(_ref) {
  var selectedTenant = _ref.selectedTenant,
      onClick = _ref.onClick;
  return _react2.default.createElement('span', null, selectedTenant && 'Acting as: ', _react2.default.createElement('a', {
    className: 'clickable',
    onClick: onClick
  }, selectedTenant || 'Select profile'));
};
/* eslint-enable jsx-a11y/no-static-element-interactions */


HeaderLink.propTypes = {
  selectedTenant: _propTypes2.default.string,
  onClick: _propTypes2.default.func.isRequired
};
HeaderLink.defaultProps = {
  selectedTenant: undefined,
  onClick: undefined
};

var TenantSelector = exports.TenantSelector = function (_Component) {
  _inherits(TenantSelector, _Component);

  function TenantSelector(props) {
    _classCallCheck(this, TenantSelector);

    var _this = _possibleConstructorReturn(this, (TenantSelector.__proto__ || Object.getPrototypeOf(TenantSelector)).call(this, props));

    _this.loadTenants = function () {
      _this.setState({
        fetchingFulfillers: true,
        fetchingMerchants: true,
        fetchingSettings: true
      });

      var resourceType = _this.props.resourceType; // load data if it doesn't exist on the static members

      Promise.all([!TenantSelector.allowedFulfillers ? (0, _fulfillerIdentity.getFulfillers)(_this.props.authToken, _this.props.environment) : Promise.resolve(TenantSelector.allowedFulfillers), !TenantSelector.allowedMerchants ? (0, _merchantConfig.getMerchants)(_this.props.authToken, _this.props.environment) : Promise.resolve(TenantSelector.allowedMerchants), !TenantSelector.savedTenants ? (0, _customizr.getSavedTenants)(_this.props.authToken, _this.props.environment) : Promise.resolve(TenantSelector.savedTenants)]).then(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 3),
            fulfillers = _ref3[0],
            merchants = _ref3[1],
            savedTenants = _ref3[2];

        var _this$props = _this.props,
            initialTenantType = _this$props.initialTenantType,
            initialTenantId = _this$props.initialTenantId,
            onInitialTenantAccessDenied = _this$props.onInitialTenantAccessDenied;
        TenantSelector.allowedMerchants = merchants || TenantSelector.allowedMerchants;
        TenantSelector.allowedFulfillers = fulfillers || TenantSelector.allowedFulfillers;
        TenantSelector.savedTenants = savedTenants || {};
        var allowedMerchants = TenantSelector.allowedMerchants || [];
        var allowedFulfillers = TenantSelector.allowedFulfillers || [];
        var selectedTenant = _this.state.selectedTenant;
        var restoredTenant = void 0;
        var initialTenantSuccess = false;

        if (initialTenantId && initialTenantType) {
          var tenant = void 0;

          switch (initialTenantType) {
            case _constants.MERCHANT:
              {
                tenant = allowedMerchants.find(function (m) {
                  return m.merchantId === initialTenantId;
                });

                if (tenant) {
                  restoredTenant = {
                    tenant: tenant,
                    type: _constants.MERCHANT
                  };
                }

                break;
              }

            case _constants.FULFILLER:
              {
                tenant = allowedFulfillers.find(function (f) {
                  return f.fulfillerId === initialTenantId || String(f.fulfillerId) === initialTenantId;
                });

                if (tenant) {
                  restoredTenant = {
                    tenant: tenant,
                    type: _constants.FULFILLER
                  };
                }

                break;
              }
          }

          if (restoredTenant) {
            initialTenantSuccess = true;
          } else {
            onInitialTenantAccessDenied({
              initialTenantId: initialTenantId,
              initialTenantType: initialTenantType
            });
          }
        }

        if (!initialTenantSuccess && savedTenants.selectedTenant && (!resourceType || savedTenants.selectedTenant.tenantType === resourceType)) {
          switch (savedTenants.selectedTenant.resourceType) {
            case _constants.MERCHANT:
              restoredTenant = {
                tenant: allowedMerchants.find(function (m) {
                  return m.merchantId === savedTenants.selectedTenant.value;
                }),
                type: _constants.MERCHANT
              };
              break;

            case _constants.FULFILLER:
              restoredTenant = {
                // checking both id types to more gracefully migrate to the newer fulfillerId value
                tenant: allowedFulfillers.find(function (f) {
                  return f.fulfillerId === savedTenants.selectedTenant.value || f.internalFulfillerId === savedTenants.selectedTenant.value;
                }),
                type: _constants.FULFILLER
              };
              break;
          }
        } else if (resourceType === _constants.MERCHANT && savedTenants.recentMerchant) {
          restoredTenant = {
            tenant: allowedMerchants.find(function (m) {
              return m.merchantId === savedTenants.recentMerchant.value;
            }),
            type: _constants.MERCHANT
          };
        } else if (resourceType === _constants.FULFILLER && savedTenants.recentFulfiller) {
          restoredTenant = {
            // checking both id types to more gracefully migrate to the newer fulfillerId value
            tenant: allowedFulfillers.find(function (f) {
              return f.fulfillerId === savedTenants.recentFulfiller.value || f.internalFulfillerId === savedTenants.recentFulfiller.value;
            }),
            type: _constants.FULFILLER
          };
        }

        if (restoredTenant && restoredTenant.tenant) {
          var details = _this.onChange(restoredTenant, initialTenantSuccess ? _this.save : undefined);

          selectedTenant = {
            value: details.tenantId,
            label: details.tenantName,
            resourceType: details.tenantType
          };
        }

        var selectedMerchant = savedTenants.recentMerchant && savedTenants.recentMerchant.value;
        var selectedFulfiller = savedTenants.recentFulfiller && savedTenants.recentFulfiller.value; // if there is a selected tenant notify the application

        if (selectedTenant) {
          if (selectedTenant.resourceType === _constants.MERCHANT && selectedTenant.value) {
            selectedMerchant = selectedTenant.value;
          }

          if (selectedTenant.resourceType === _constants.FULFILLER && selectedTenant.value) {
            selectedFulfiller = selectedTenant.value;
          }

          _this.props.onCurrentTenantChange(selectedTenant);
        } //notify the application that the selector is ready


        _this.props.onReady();

        _this.setState({
          fetchingFulfillers: false,
          fetchingMerchants: false,
          fetchingSettings: false,
          allowedMerchants: allowedMerchants,
          allowedFulfillers: allowedFulfillers,
          selectedTenant: selectedTenant,
          selectedMerchant: selectedMerchant,
          selectedFulfiller: selectedFulfiller
        });
      }).catch(function (error) {
        return console.error(error);
      });
    };

    _this.onChange = function (tenant, cb) {
      var selection = tenant.tenant || {};
      var newState = {
        tenantType: tenant.type
      };

      if (tenant.type === _constants.MERCHANT) {
        newState.tenantId = selection.merchantId;
        newState.tenantName = selection.displayName;
        newState.selectedMerchant = selection.merchantId;
      } else {
        newState.tenantId = selection.fulfillerId;
        newState.tenantName = selection.name;
        newState.selectedFulfiller = selection.fulfillerId;
      }

      _this.setState(newState, cb);

      return newState;
    };

    _this.showModal = function () {
      var _ref4 = _this.state.selectedTenant || {},
          value = _ref4.value,
          label = _ref4.label,
          resourceType = _ref4.resourceType;

      _this.setState({
        showModal: true,
        tenantId: value,
        tenantName: label,
        tenantType: resourceType || _this.props.resourceType
      });
    };

    _this.closeModal = function () {
      if (_this.props.onClose) {
        _this.props.onClose();
      }

      _this.setState({
        showModal: false
      });
    };

    _this.save = function () {
      var _this$state = _this.state,
          tenantId = _this$state.tenantId,
          tenantName = _this$state.tenantName,
          tenantType = _this$state.tenantType;
      var tenant = {
        value: tenantId,
        label: tenantName,
        resourceType: tenantType
      };

      _this.setState({
        selectedTenant: tenant
      });

      var savedSetting = {
        selectedTenant: tenant
      };

      if (tenantType === _constants.MERCHANT) {
        savedSetting.recentMerchant = tenant;
      }

      if (tenantType === _constants.FULFILLER) {
        savedSetting.recentFulfiller = tenant;
        var fulfiller = (0, _lodash2.default)(_this.state.allowedFulfillers, function (tenant) {
          return tenant.fulfillerId === tenantId;
        });
        tenant.altValue = fulfiller ? fulfiller.internalFulfillerId : null;
      }

      TenantSelector.savedTenants = _extends({}, TenantSelector.savedTenants, savedSetting);
      (0, _customizr.putSavedTenants)(_this.props.authToken, _this.props.environment, TenantSelector.savedTenants);

      _this.props.onCurrentTenantChange(tenant);

      _this.closeModal();
    };

    _this.state = {
      selectedTenant: null,
      // backwards-compatibility with Customizr
      selectedMerchant: null,
      selectedFulfiller: null,
      allowedMerchants: [],
      allowedFulfillers: [],
      showModal: false
    };
    return _this;
  }

  _createClass(TenantSelector, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.loadTenants();

      if (this.props.resourceType) {
        this.setTenantTypeStateFromProps();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.resourceType !== prevProps.resourceType) {
        this.setTenantTypeStateFromProps();
      }

      if (this.props.show && !prevProps.show) {
        this.showModal();
      } else if (!this.props.show && prevProps.show && this.state.showModal) {
        this.setState({
          showModal: false
        });
      }
    }
  }, {
    key: 'setTenantTypeStateFromProps',
    value: function setTenantTypeStateFromProps() {
      this.setState({
        tenantType: this.props.resourceType
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          selectedTenant = _state.selectedTenant,
          selectedMerchant = _state.selectedMerchant,
          selectedFulfiller = _state.selectedFulfiller,
          showModal = _state.showModal,
          tenantType = _state.tenantType,
          tenantName = _state.tenantName,
          tenantId = _state.tenantId,
          allowedMerchants = _state.allowedMerchants,
          allowedFulfillers = _state.allowedFulfillers,
          fetchingFulfillers = _state.fetchingFulfillers,
          fetchingMerchants = _state.fetchingMerchants;

      var _ref5 = selectedTenant || {},
          label = _ref5.label;

      var _props = this.props,
          authToken = _props.authToken,
          resourceType = _props.resourceType,
          forceSelection = _props.forceSelection,
          showLink = _props.showLink,
          show = _props.show,
          modalTitle = _props.modalTitle,
          modalHelpText = _props.modalHelpText;
      var mustSelectTenant = !selectedTenant && forceSelection;

      if (!fetchingFulfillers && !fetchingMerchants && allowedMerchants.length + allowedFulfillers.length === 0) {
        return _react2.default.createElement(_Modal2.default, {
          className: 'modal-overflow',
          show: showModal || show || mustSelectTenant,
          title: 'No permissions',
          onRequestHide: this.closeModal,
          closeButton: !mustSelectTenant,
          bsStyle: 'danger',
          footer: _react2.default.createElement('div', {
            className: 'pull-right'
          }, _react2.default.createElement('button', {
            className: 'btn btn-default',
            disabled: mustSelectTenant,
            onClick: this.closeModal
          }, 'Close'))
        }, "You do not have permission to access this application. Please contact your administrator to provide you with access. If you don\u2019t know who your administrator is, contact", ' ', _react2.default.createElement('a', {
          href: 'https://cimpress-support.atlassian.net/servicedesk/customer/portal/6',
          target: '_blank',
          rel: 'noopener noreferrer'
        }, 'Platform Support.'));
      } // TODO: fix test environment so that document is not undefined
      // @cimpress/react-components/lib/Modal blows up on any reference to document.body


      return _react2.default.createElement('div', {
        style: showLink ? {
          marginTop: '13px'
        } : {}
      }, showLink ? _react2.default.createElement(HeaderLink, {
        onClick: this.showModal,
        selectedTenant: label
      }) : null, _react2.default.createElement(_SelectorModal2.default, {
        authToken: authToken,
        show: showModal || show,
        selectedMerchant: selectedMerchant,
        selectedFulfiller: selectedFulfiller,
        mustSelectTenant: mustSelectTenant,
        onClose: this.closeModal,
        onSave: this.save,
        canSave: !!(tenantId && tenantName && tenantType),
        loading: fetchingFulfillers || fetchingMerchants,
        onChange: this.onChange,
        merchants: allowedMerchants,
        fulfillers: allowedFulfillers,
        resourceType: resourceType || tenantType || '',
        title: modalTitle,
        helpText: modalHelpText
      }));
    }
  }]);

  return TenantSelector;
}(_react.Component);

TenantSelector.propTypes = {
  authToken: _propTypes2.default.string.isRequired,
  onCurrentTenantChange: _propTypes2.default.func.isRequired,
  resourceType: _propTypes2.default.string,
  initialTenantType: _propTypes2.default.oneOf([_constants.MERCHANT, _constants.FULFILLER]),
  initialTenantId: _propTypes2.default.string,
  forceSelection: _propTypes2.default.bool,
  show: _propTypes2.default.bool,
  environment: _propTypes2.default.string,
  showLink: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  modalTitle: _propTypes2.default.string,
  modalHelpText: _propTypes2.default.string,
  onReady: _propTypes2.default.func,
  onInitialTenantAccessDenied: _propTypes2.default.func
};
TenantSelector.defaultProps = {
  environment: 'prd',
  resourceType: '',
  forceSelection: false,
  showLink: false,
  show: false,
  onClose: noop,
  modalTitle: 'Choose who to view',
  modalHelpText: '',
  onReady: noop,
  onInitialTenantAccessDenied: noop
};
exports.default = TenantSelector;